import React, { useEffect } from "react";
import './App.css';
import { BrowserRouter as Router, Switch, Route, useHistory } from 'react-router-dom';
import SearchNav from './function-components/Searchnav';
import Footer from './function-components/Footer';
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from './function-components/PageLayout';
import LearningCalendarPage from "./pages/LearningCalendarPage";
import Sample from "./pages/Sample";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}
function Pages() {
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  useEffect(() => {    
    if (activeAccount) {      
      fetchAccessToken()      
    }
  }, [activeAccount]);
  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    try {      
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount
      });
      const bearer = `Bearer ${response.accessToken}`;      
      localStorage.setItem("token", bearer) 
      console.log(bearer, "beareerrr")     
    }
    catch (error) {
      console.error('Error fetching access token:', error);
      localStorage.clear()
    }
  };
  return (
    // <MsalProvider instance={pca}>
    <PageLayout>
      <div container justifyContent="center">
        <Router basename={"/learning-calendar"}>
          <SearchNav />
          {/* <Sample /> */}
          <LearningCalendarPage />

          {/* <Home /> */}
          {/* <Navbarmenu /> */}
          <Switch>
          </Switch>
        </Router>
        <Footer />
      </div>
    </PageLayout>
    // </MsalProvider>
  );
}

export default App;
